import { Badge } from '@/components';
import { InboxStatus } from '../models';

interface BadgeColors {
  bg: string;
  text: string;
}

const green: BadgeColors = { bg: '#C8E6C9', text: '#2E7D32' };
const orange: BadgeColors = { bg: '#FFE0B2', text: '#EF6C00' };
const gray: BadgeColors = { bg: '#E0E0E0', text: '#121212' };
const red: BadgeColors = { bg: '#FFCDD2', text: '#C62828' };

export const inboxStatusTranslation: Record<InboxStatus, string> = {
  SCHEDULED_PENDING: 'AÚN NO CONFIRMADO',
  PENDING: 'PENDIENTE',
  ATTENDING: 'ATENDIENDO',
  FINALIZED_NOT_DELIVERED: 'NO ENTREGADO',
  FINALIZED_DELIVERED: 'ENTREGADO',
  UNKNOWN: 'DESCONOCIDO',
};

export const inboxStatusColors: Record<InboxStatus, BadgeColors> = {
  SCHEDULED_PENDING: orange,
  PENDING: orange,
  ATTENDING: orange,
  FINALIZED_NOT_DELIVERED: red,
  FINALIZED_DELIVERED: green,
  UNKNOWN: gray,
};

const getColorProps = (
  colors: Record<InboxStatus, BadgeColors>,
  value: InboxStatus
) => ({
  backgroundColor: colors[value].bg,
  ballColor: colors[value].text,
});

const renderStatus = (status: InboxStatus | undefined): JSX.Element => {
  const validStatus: InboxStatus =
    status && inboxStatusTranslation[status] ? status : 'UNKNOWN';

  const colorProps = getColorProps(inboxStatusColors, validStatus);

  return (
    <div style={{ width: 'fit-content' }}>
      <Badge {...colorProps} value={inboxStatusTranslation[validStatus]} />
    </div>
  );
};

export default renderStatus;
